import { useQuery } from 'react-query'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { useOrganizationUiSetup } from '../../../hooks/useOrganizationUiSetup'
import { fetchZervantSubscription } from '../query-api'

export const useFetchZervantSubscription = () => {
  const { isUiSetupAccounting } = useOrganizationUiSetup()
  const {
    data: zervantSubscriptionData,
    isLoading,
    ...rest
  } = useQuery(QueryKeys.ZervantSubscription, fetchZervantSubscription, {
    enabled: !isUiSetupAccounting, // Zervant api is not available in Billy app
    staleTime: defaultStaleTime,
  })

  return { zervantSubscription: zervantSubscriptionData?.data, isLoading, ...rest }
}
